import { render, staticRenderFns } from "./__SpecProductUnit.vue?vue&type=template&id=7f4815bb&"
import script from "./__SpecProductUnit.vue?vue&type=script&lang=js&"
export * from "./__SpecProductUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports